import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, Toast],
    templateUrl: './app.html',
    providers: [MessageService],
})
export class App {
    protected readonly title = signal('atc-web');
}
